angular.module("hippo-theme.templates", ["hippo-icon/hippo-icon.tpl.html", "tree/tree-include.tpl.html", "tree/tree.tpl.html"]);

angular.module("hippo-icon/hippo-icon.tpl.html", []).run(["$templateCache", function($templateCache) {
  "use strict";
  $templateCache.put("hippo-icon/hippo-icon.tpl.html",
    "<svg ng-class=\"className\"><use xlink:href=\"{{xlink}}\"/></svg>");
}]);

angular.module("tree/tree-include.tpl.html", []).run(["$templateCache", function($templateCache) {
  "use strict";
  $templateCache.put("tree/tree-include.tpl.html",
    "<div ui-tree-handle data-ng-click=\"selectItem()\"><div hippo-tree-template></div></div><ol ui-tree-nodes ng-model=\"item.items\" ng-if=\"!collapsed\"><li ng-repeat=\"item in item.items\" ui-tree-node data-hippo-node-template-url=\"tree/tree-include.tpl.html\" ng-if=\"displayTreeItem(item)\" data-ng-class=\"{active: selectedItem.id == item.id}\" scroll-to-if=\"selectedItem.id == item.id\" data-collapsed=\"item.collapsed\"></li></ol>");
}]);

angular.module("tree/tree.tpl.html", []).run(["$templateCache", function($templateCache) {
  "use strict";
  $templateCache.put("tree/tree.tpl.html",
    "<div ui-tree=\"options\" ng-class=\"{\n" +
    "       'drag-enabled': drag == true,\n" +
    "       'drag-disabled': drag == false,\n" +
    "     }\" data-drag-enabled=\"drag\"><ol ui-tree-nodes ng-model=\"treeItems\"><li ng-repeat=\"item in treeItems\" ui-tree-node data-hippo-node-template-url=\"tree/tree-include.tpl.html\" data-ng-class=\"{active: selectedItem.id == item.id}\" scroll-to-if=\"selectedItem.id == item.id\" data-collapsed=\"item.collapsed\"></li></ol></div>");
}]);
